import React from 'react';

import ScrollLink from 'react-anchor-link-smooth-scroll';

export const BlakeHeader = () => {
  return (
    <header className="absolute w-full px-gutter flex justify-end py-10 z-2000">
      <ScrollLink
        href="#enquire"
        className="bg-white text-oslo-green text-xl rounded-full px-6 py-2"
      >
        Enquire Now
      </ScrollLink>
    </header>
  );
};
